var AbstractTracker = require("app/Analytics/AbstractTracker"),
    config          = require("app/config"),
    deepEqual       = require("fast-deep-equal"),
    get             = require("object-path").get,
    kind            = require("enyo/kind"),
    logger          = require("enyo/logger");

module.exports = kind(/** @lends  app.Analytics.TraceDock.prototype */ {

    /**
     * @private
     */
    name: "app.Analytics.TraceDock",

    /**
     * @private
     */
    kind: AbstractTracker,

    /**
     * Whether the tracker is form an IAB Vendor.
     */
    isNonIABVendor: true,

    /**
     * Cached copy of consent data, used to detect consent changes.
     *
     * @private
     */
    consent: null,

    // Vendor Transparency and Consent
    // ----------------

    /**
     * Respond to changes in consent.
     *
     * @private
     */
    onNonIABConsentDataChange: function() {
        var $privacyService = this.app.$.privacyService,
            consent         = $privacyService.get("nonIABConsentData"),
            consentChanged  = !deepEqual(this.consent, consent);

        // Update consent state
        if (consentChanged) {
            this.consent = consent;
        }
        else {
            return;
        }

        // We are not responsible for loading ourselves
        if (get(config, "traceDock.loader", null) !== "self") {
            return;
        }

        // We aren't ready yet, but are allowed to load.
        if (!this.isReady && this.hasLoadConsent()) {
            this.load();
        }

        // We are ready, but consent has just been revoked.
        else if (this.isReady && !this.hasLoadConsent()) {
            this.app.$.router.reload();
        }
    },

    // Loading
    // ----------------

    /**
     * @returns  {boolean}  Whether we have consent to load the TraceDock
     * @private
     */
    hasLoadConsent: function() {
        var $privacyService   = this.app.$.privacyService,
            nonIABConsentData = $privacyService.get("nonIABConsentData");

        // Bypass parameter set
        if ($privacyService.shouldBypassConsent()) {
            return true;
        }

        // Consent for 'advertisement' purpose required
        else {
            return nonIABConsentData
                && nonIABConsentData.accepted
                && Array.isArray(nonIABConsentData.accepted)
                && nonIABConsentData.accepted.includes("analytics");
        }
    },

    /**
     * @return {string|null} The loader
     * @public
     */
    getLoader: function() {
        return get(config, "traceDock.loader", null);
    },

    /**
     * Mostly the same code as the incoming snippet (hence the obtuse code),
     * modified only to double-check for sufficient configuration and to track
     * loading state.
     *
     * @private
     */
    load: function() {
        var e,
            t,
            n,
            r,
            o,
            i,
            u,
            c,
            a,
            l;

        // TraceDock not enabled
        if (!get(config, "traceDock.enabled", false)
            || get(config, "traceDock.loader", null) !== "self"
            || !get(config, "traceDock.domain", false)
            || !get(config, "traceDock.url", false)) {
            return;
        }

        // Bail if already loaded
        if (this.isReady) {
            return;
        }

        // Initial values
        e = get(config, "traceDock.domain", false);
        t = new URL(get(config, "traceDock.url", false));
        t = t.toString();
        n = document;
        a = n.getElementsByTagName("head")[0];

        // Load script
        l         = n.createElement("script");
        l.async   = true;
        l.src     = t;
        l.onload  = this.onLoad;
        l.onerror = this.onLoadError;
        a.appendChild(l);

        /* eslint-disable */
        // Some bootstrapping, copied from the script provided by cm.com
        try {
            if (i = (" " + r).match(new RegExp("[; ]_tdbu=([^\\s;]*)"))) {
                for (u in o = decodeURI(i[1]).split("||")) {
                    (c = o[u].split("~~"))[1] && (r.indexOf(c[0] + "=") > -1 || (n.cookie = c[0] + "=" + c[1] + ";path=/;max-age=604800;domain=." + e, n.cookie = "_1=1"));
                }
            }
        }
        catch (error) {
            logger.error(error);

            if (typeof Sentry !== "undefined" && error instanceof Error) {
                Sentry.captureException(error);
            }
        }
        /* eslint-enable */
    },

    /**
     * @returns  {boolean}  `true` when ready, `false` otherwise.
     * @private
     */
    verifyReadiness: function() {
        return typeof td !== "undefined" ? true : false;
    },

    /**
     * @private
     */
    onReady: kind.inherit(function(sup) {
        return function() {
            // Consent has been revoked while we were getting ready
            if (get(config, "traceDock.loader", null) === "self"
                && !this.hasLoadConsent()) {
                this.app.$.router.reload();

                return;
            }

            sup.apply(this, arguments);
        };
    })

});
